export default __webpack_public_path__ + "static/mockStress1-55b0419e0f510134d420190437a233b9.png";